export var XRGestureType;
(function (XRGestureType) {
    XRGestureType[XRGestureType["Grab"] = 100] = "Grab";
    XRGestureType[XRGestureType["Release"] = 101] = "Release";
    XRGestureType[XRGestureType["Pinch"] = 102] = "Pinch";
    XRGestureType[XRGestureType["Point"] = 1033] = "Point";
    XRGestureType[XRGestureType["Swipe"] = 104] = "Swipe";
    XRGestureType[XRGestureType["Custom"] = 999] = "Custom";
})(XRGestureType || (XRGestureType = {}));
//# sourceMappingURL=map.inputs.interfaces.hands.js.map